import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { IVotingQuestions } from "../../models/VotingQuestions";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { EmptyVotingQuestions } from "../../models/VotingQuestions";
import { IModel } from "./Voting";
import { Answer } from "./Answer";
import { ILogin, IPermissionProps } from "../../models/Login";
import { format } from "date-fns";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface Iprops {
    // singleData: IVotingQuestions
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    shwAddQes: boolean,
    shwUpdateQes: boolean,
    permissions: IPermissionProps
}

export interface IModel2 {
    open: boolean,
    singleData: IVotingQuestions,
    isActive: string | boolean
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IVotingQuestions>, loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [answer, setAnswer] = useState({ singleData: {}, open: false, isActive: false } as IModel2);

    const [globalFilter, setGlobalFilter] = useState<string | null>(null);

    const [isAdmin, setIsAdmin] = useState(false);

    const dt = useRef<any>(null);

    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: '',
        sortOrder: -1
    });

    useEffect(() => {
        const sessionData = JSON.parse(sessionStorage.getItem("auth") || "");

        if (sessionData.roles) {
            sessionData.roles.forEach((el: { role_ID: number }) => {
                if (el.role_ID === 1 || el.role_ID === 26) {
                    setIsAdmin(true);
                }
            });
        }
    }, []);

    useEffect(() => {
        getTableDataCount();
        loadTableData();
    }, [globalFilter, lazyParams, props.reload]);

    const hideTHistory = () => {
        setAnswer({ singleData: {}, open: false, isActive: false });
    }
    const openTHistory = (rowData: IVotingQuestions, value: string | boolean) => {
        rowData.voting_Que_ID && setAnswer({ singleData: rowData, open: true, isActive: value });
    }
    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }



    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }



    const getTableDataCount = async () => {
        const response = await Fetch("Voting_Questions/count", "GET", null, `filter=${globalFilter}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Voting_Questions", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${globalFilter}`, props.toast);
        if (response) {
            let data: Array<IVotingQuestions> = await response.json();

            data = data.map((el) => {
                if (el.submitted_Answer === 1) {
                    el.submitted_Answer = "Yes";
                } else if (el.submitted_Answer === 0) {
                    el.submitted_Answer = "No";
                } else {
                    el.submitted_Answer = "";
                }
                el.submitted_Date = el.submitted_Date?.split("T")[0];
                return el;
            });

            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyVotingQuestions });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };



    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Questions</h5>
        </div>
    );

    const actionBodyTemplate = (rowData: IVotingQuestions) => {
        function openEdit(rowData: IVotingQuestions): void {
            // throw new Error("Function not implemented.");
            //console.log(rowData);
            props.setModal({ open: true, singleData: rowData });
        }

        let value: string | boolean = "";

        if (rowData.expiry_Date != null) {
            let isDate = rowData.expiry_Date.toString().split("/");
            value = new Date().getFullYear() <= Number(isDate[2]) ? (new Date().getMonth() + 1) <= Number(isDate[1]) ? new Date().getDate() <= Number(isDate[0]) ? "Active" : "In-Active" : "Active" : "In-Active";
        }


        return (
            <div className="actions flex align-items-center">
                <i className="pi pi-circle-fill " style={{ padding: "20px", color: value === "Active" ? 'green' : "red" }} >{value}</i>

                <i className="pi pi-eye cursor-pointer text-cyan-700" style={{ padding: "20px" }} onClick={() => openTHistory(rowData, value)}></i>

                {props.shwUpdateQes && <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1 " onClick={() => openEdit(rowData)} />}
            </div>
        );
    };


    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;


    return (
        <>
            {props.shwAddQes && <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>}
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Company found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="question" header="Question" sortable />
                {/* <Column field="expiry_Date" header="Voting Closed On" /> */}
                <Column field="expiry_Date" header="Voting Closed On" body={(rowData: any) => safeFormatDate(rowData.expiry_Date, 'dd/MM/yyyy', DateFormat)} />
                {/* <Column field="submitted_Date" header="Answer Date" /> */}
                <Column field="submitted_Date" header="Answer Date" body={(rowData: any) =>safeFormatDate( rowData.submitted_Date, "dd/MM/yyyy", DateFormat, )}/>
                <Column field="submitted_Answer" header="Your Answer" />
                <Column field="total_Yes" header="Yes" />
                <Column field="total_No" header="No" />
                <Column field="yes_Per" header="Yes%" />
                <Column field="no_Per" header="No%" />
                <Column field="total_Answer" header="Total Answer" />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <Answer singleData={answer.singleData} hideDialog={hideTHistory} isActive={answer.isActive} open={answer.open} isAdmin={isAdmin} toast={undefined} loadTableData={loadTableData}></Answer>

        </>
    );
}
